export default __webpack_public_path__ + "static/media/SeyahatMasrafLimitTablosu2026.43751fe2.png";